import type { ComponentProps } from 'react';
import type React from 'react';

import { ClientRender } from '@change-corgi/core/react/ssr/render';
import { Loader } from '@change-corgi/design-system-legacy/components/progressiveDisclosure';
import { useCurrentBreakpointValue } from '@change-corgi/design-system-legacy/responsive';

import { LazyComponent } from 'src/app/shared/components/layout/lazy';

import type { ShareContainer } from './Share';

async function loadShare(): Promise<typeof ShareContainer> {
	return (await import(/* webpackChunkName: "pages/petition_details_share" */ './Share')).ShareContainer;
}

const ShareLoaderInner: React.FC<ComponentProps<typeof ShareContainer>> = (props) => {
	return <LazyComponent loadComponent={loadShare} fallback={<Loader size="s" mt={64} mx="auto" />} {...props} />;
};

const ShareLoaderForDesktopView: React.FC<ComponentProps<typeof ShareContainer>> = ({
	forMobileView,
	...restProps
}) => {
	const desktop = useCurrentBreakpointValue([false, true]);

	return desktop ? (
		<ShareLoaderInner forMobileView={forMobileView} {...restProps} />
	) : (
		<Loader size="s" mt={64} mx="auto" />
	);
};

export const ShareLoader: React.FC<ComponentProps<typeof ShareContainer>> = ({ forMobileView, ...restProps }) => {
	if (forMobileView) {
		return <ShareLoaderInner forMobileView={forMobileView} {...restProps} />;
	}

	return (
		<ClientRender placeholder={<Loader size="s" mt={64} mx="auto" />}>
			<ShareLoaderForDesktopView forMobileView={forMobileView} {...restProps} />
		</ClientRender>
	);
};

export const preloadShare = loadShare;
